import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';
const BATCH_API_URL = `${API_HOST}/api/product/batch`;

function* productBatchCodeList() {
  yield takeEvery(actions.PRODUCT_BATCH_CODE_LIST, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${BATCH_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PRODUCT_BATCH_CODE_LIST_ENDED });
    }
  });
}

function* productBatchCodeInfoList() {
  yield takeEvery(actions.PRODUCT_BATCH_CODE_INFO_LIST, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${BATCH_API_URL}/code?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PRODUCT_BATCH_CODE_INFO_LIST_ENDED });
    }
  });
}

function* createVerificationCode() {
  yield takeEvery(actions.CREATE_PRODUCT_BATCH_CODE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], BATCH_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_PRODUCT_BATCH_CODE_ENDED });
    }
  });
}

function* updateVerificationCode() {
  yield takeEvery(actions.PUT_PRODUCT_BATCH_CODE, function* (action) {
    const { formData, onSuccess, id } = action;
    try {
      const res = yield call([axios, 'put'], `${BATCH_API_URL}/${id}`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PUT_PRODUCT_BATCH_CODE_ENDED });
    }
  });
}

function* deleteVerificationCode() {
  yield takeEvery(actions.DELETE_PRODUCT_BATCH_CODE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${BATCH_API_URL}`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_PRODUCT_BATCH_CODE_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createVerificationCode),
    fork(productBatchCodeList),
    fork(productBatchCodeInfoList),
    fork(updateVerificationCode),
    fork(deleteVerificationCode),
  ]);
}
